import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
  uri: 'https://fb983434-801c-4ee4-9e9a-8596fee297e8.dreamhosters.com/graphql',
  cache: new InMemoryCache(),
});

export default client;
